<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">
        <div class="xblock layui-form">
          <button type="button" lay-submit class="layui-btn">
            <input style="width: 100px;" accept="image/*" class="addimginput upload_img" data-te="waterprint" multiple type="file" name="img">
            上传图片
          </button>
          <button class="layui-btn layui-btn-danger nav-btn" v-on:click="ConfirmHint(2)">批量删除</button>
          <div class="space-capacity">
            <div class="space-capacity-box">
              <a class="space-capacity-txt">已用 <i v-text="space.space_count"></i> MB/ <i v-text="space.space_limit"></i>
                MB</a>
              <a class="space-capacity-btn status-box-green" v-on:click="OpenPage('Servicelimit')">容量升级</a>
            </div>
            <div class="layui-progress">
              <div class="layui-progress-bar" :lay-percent="space.percentage+'%'"></div>
            </div>
          </div>
        </div>

        <table class="layui-table layui-form">
          <thead>
            <tr>
              <th style="width: 20px;">
                <input type="checkbox" class="cxall" lay-filter="cxall" name="cxall" lay-skin="primary">
              </th>
              <th style="width: 80px;">图片</th>
              <th>名称</th>
              <th>大小</th>
              <th>时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody v-viewer>
            <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
              <td class="cx-box" :data-ix="index">
                <input type="checkbox" lay-filter="cx" lay-skin="primary" :data-index="index" :checked="item.active">
              </td>
              <td>
                <div class="table_img col-img" :style="{'background-image': 'url('+item.url+')'}">
                  <img class="viewerimg" :src="item.url">
                </div>
              </td>
              <td v-text="item.name"></td>
              <td v-text="item.size+' KB'"></td>
              <td v-text="item.created_at"></td>
              <td class="btn-arr">
                <button class="layui-btn layui-btn-danger" v-on:click="ConfirmHint(1,item.id)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

        <!--scroll to top-->
        <div class="scroll-top">
        	<i class="fa fa-angle-up" aria-hidden="true"></i>
        </div>
      </div>

    </div>

    <!-- 分页 -->
    <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
  var self, form, layer, laypage, element;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Space',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        item: null,
        isLoding: true,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        total: 0,
        page_num:20,
        current_status: 0,
        status_id: 0,
        list: [],
        data_total: {
          amount_invested: 0,
          escrow_amount: 0,
          total_amount: 0,
          profit: 0,
          profit_margin: 0
        },
        status: [{
          id: 1,
          name: "打包"
        }],
        space: {
          space_count: 0,
          space_limit: 300,
          percentage: 0
        }
      }
    },
    updated() {
      if (form) {
        form.render();
      }
      if (element) {
        element.render();
      }
    },
    mounted() {
      self = this;
      self.SetNavActive("上架",self.$route.name);
      scrollTop(); //监听滚动置顶
      layui.use(['form', 'layer', 'laypage', 'element'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        element = layui.element;

        //全选
        form.on('checkbox(cxall)', function(data) {
          var child = $(".cx-box input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = data.elem.checked;
            self.list[index].active = status;
          });
          form.render('checkbox');
        });

        //单选
        form.on('checkbox(cx)', function(data) {
          console.log(data)
          let ix = data.elem.dataset.index;
          let status = data.elem.checked;
          self.list[ix].active = status;
          form.render('checkbox');
        });

        //单选
        $("#main-box").on("click", '.cx-box', function(e) {
          var ix = $(this).attr("data-ix");
          if (self.list[ix].active) {
            self.list[ix].active = false;
          } else {
            self.list[ix].active = true;
          }
          form.render('checkbox');
        });

        //图片上传
        $("#main-box").on("change", ".upload_img", function(event) {
          var _this = $(this);
          var $file = event.currentTarget;
          var formData = new FormData();
          var file = $file.files;

          for (var i = 0; i < file.length; i++) {
            formData.append(file[i].name, file[i]);
          }

          self.loading = true;
          $.ajax({
            url: self.GetServerUrl() + "/update_file/",
            type: 'post',
            dataType: 'json',
            data: formData,
            contentType: false,
            processData: false,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            },
            success: function(res) {
              self.loading = false;
              layer.msg(res.msg);
              if (res.code == 200) {
                _this.val(""); //清空图片选中
                self.GetList();
              }
            },
            error: function(error) {
              self.loading = false;
              layer.msg(error);
            }
          })
        })

        self.GetList()
        self.GetUserSpace();
      });
    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      GetList() {
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        axios({
          method: 'post',
          data: param,
          url: self.GetServerUrl() + "/user_space/?page="+self.page,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;
          self.GetUserSpace();

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if (datas.page) {
              let list = datas.list;
              for (let i in list) {
                list[i].active = false;
                list[i].size = (list[i].size / 1024).toFixed(2);
              }
              self.list = list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "GetList"); //分页
              $('.pagebox').show();
            }
          },function(){
            self.list = [];
            self.count = 0; //页数
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.GetList();
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          console.log(error);
        })
      },
      GetUserSpace() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_user_space/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            datas.percentage = Math.round(datas.space_count / datas.space_limit * 100);
            self.space = datas;
          });

        }).catch(function(error) {
          console.log(error);
        })
      },
      ConfirmHint(te, item) {
        self.Confirm.style = 2;
        self.Confirm.state = true;
        self.Confirm.txt = "是否确认删除？"
        self.Confirm.type = te;

        if (te == 1) {
          self.item = [item];
        } else {
          let list = [];
          for (let i in self.list) {
            if (self.list[i].active) {
              list.push(self.list[i].id);
            }
          }
          self.item = list;
        }
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {
          self.loading = true;
          self.Confirm.state = false;
          let param = new URLSearchParams()
          param.append('ids', JSON.stringify(self.item))
          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/del_user_files/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              $('.cxall').prop('checked', false);
              self.GetList();
            }, false, true);

          }).catch(function(error) {
            self.loading = false;
            console.log(error);
          })
        }
      },
      OpenPage(url) {
        localStorage.setItem("ExShopee_HistoryURL",url);
        self.GoToPage('/'+url); // 路由跳转
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .xblock {
    padding: 12px 10px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Space.vue